<template>
  <div class="p-42 my-52 connections-container">
    <div class="relative">
      <div @click.prevent="showVideo" class="absolute-header" style="top: -17px; right: 0">
        <div class="button-header flex-mid">
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <div>
      <div class="fs-18 fw-900">
        {{ $t("weMonthlyInsights.connections.howAreWe") }}
      </div>
      <div class="fc-15253C opa-07">
        {{ $t("weMonthlyInsights.connections.basedOnRecognition") }}
      </div>
      <div class="fs-18 fc-15253C fw-700" style="margin-top: 60px">
        {{ $t("weMonthlyInsights.connections.youHaveA") }}
        {{ userDetail.totalConnections }}
        {{ $t("weMonthlyInsights.connections.connections") }}
      </div>
      <div>
        <div class="flex mt-24">
          <img
            :src="
              require(`@/assets/images/wv-monthly-insights/connections/inner.png`)
            "
            class="skeleton-circle"
          />
          <div class="fs-16 fw-700 ml-12 opa-09">
            <div class="fc-15253C">
              {{ userDetail.innerNetwork }}
              {{ $t("weMonthlyInsights.connections.innerNetwork") }}
            </div>
            <div
              :class="`fs-13 ${
                userDetail.newInnerNetwork > 0
                  ? 'fc-0CACA5 opa-09'
                  : 'fc-000000 opa-03'
              }`"
            >
              {{ userDetail.newInnerNetwork }}
              {{ $t("weMonthlyInsights.connections.newConnectionsThis") }}
            </div>
          </div>
        </div>
        <div class="flex mt-24">
          <img
            :src="
              require(`@/assets/images/wv-monthly-insights/connections/outer.png`)
            "
            class="skeleton-circle"
          />
          <div class="fs-16 fw-700 ml-12">
            <div class="fc-15253C opa-09">
              {{ userDetail.outerNetwork }}
              {{ $t("weMonthlyInsights.connections.outerNetwork") }}
            </div>
            <div
              :class="`fs-13 ${
                userDetail.newOuterNetwork > 0
                  ? 'fc-0CACA5 opa-09'
                  : 'fc-000000 opa-03'
              }`"
            >
              {{ userDetail.newOuterNetwork }}
              {{ $t("weMonthlyInsights.connections.newConnectionsThis") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="ml-auto" style="margin: -120px 20px -40px auto">
        <div style="width: 450px; margin-left: auto">
          <relationship-mapping
            :modalMemberData="modalMemberData"
            :profile="user"
          />
        </div>
      </div>
    </div>
    <div class="fs-14 fc-15253C opa-06" style="width: 338px">
      {{ $t("weMonthlyInsights.connections.buildingRelationshipsIs") }}
    </div>
  </div>
</template>

<script>
export default {
  components: {
    relationshipMapping:
      require("../members/members-components/relationship-mapping").default,
  },
  props: {
    user: {
      id: String,
      name: String,
      firstname: String,
      lastname: String,
      month: String,
      year: String,
    },
  },
  computed: {
    modalMemberData() {
      return this.$store.getters["newmember/modalMemberData"];
    },
    userDetail() {
      return this.$store.getters["monthlyEngaged/userDetail"];
    },
  },
  created() {
    // this.$store.dispatch("monthlyEngaged/getuserDetail",this.user)

    let item = {
      ...this.user,
      boss: this.user.bossName,
    };
    this.$store.dispatch("newmember/getModalMemberData", item);
  },
  data() {
    return {
      // userDetail: {
      //   totalConnections: 0,
      //   innerNetwork: 0,
      //   newInnerNetwork: 0,
      //   outerNetwork: 0,
      //   newOuterNetwork: 0,
      // },
    };
  },
  methods: {
    showVideo() {
      this.$emit("dialogValue", {value:true, text: "section-4"})
    }
  }
};
</script>

<style lang="scss" scoped>
.skeleton-circle {
  width: 42px;
  height: 42px;
  border-radius: 42px;
  background-color: rgba($color: #000000, $alpha: 0.3);
}
</style>